import apiCall from "@/network/apiCall";
import { CUSTOMERS_URLS } from "@/network/api";
import { RequestMethod } from "@/utils/Enums";

import {
  Login,
  Register,
  ResendVerification,
  UpdatePhone,
  UpdateProfile,
  VerificationBase,
} from "@/types/dtos/customers";

const CustomersRepository = () => {
  const login = async (bodyObj: Login) => {
    const data = await apiCall(
      CUSTOMERS_URLS.Login,
      RequestMethod.POST,
      bodyObj
    );
    return data;
  };

  const register = async (bodyObj: Register) => {
    const data = await apiCall(
      CUSTOMERS_URLS.Register,
      RequestMethod.POST,
      bodyObj
    );
    return data;
  };

  const resendVerification = async (bodyObj: ResendVerification) => {
    const data = await apiCall(
      CUSTOMERS_URLS.ResendVerification,
      RequestMethod.POST,
      bodyObj
    );
    return data;
  };

  const verifyRegistration = async (bodyObj: VerificationBase) => {
    const data = await apiCall(
      CUSTOMERS_URLS.VerifyRegistration,
      RequestMethod.POST,
      bodyObj
    );
    return data;
  };

  const verifyLogin = async (bodyObj: VerificationBase) => {
    const data = await apiCall(
      CUSTOMERS_URLS.VerifyLogin,
      RequestMethod.POST,
      bodyObj
    );
    return data;
  };
  const updatePhone = async (bodyObj: UpdatePhone) => {
    const data = await apiCall(
      CUSTOMERS_URLS.UpdatePhone,
      RequestMethod.POST,
      bodyObj
    );
    return data;
  };
  const verifyUpdatePhone = async (bodyObj: VerificationBase) => {
    const data = await apiCall(
      CUSTOMERS_URLS.VerifyUpdatePhone,
      RequestMethod.POST,
      bodyObj
    );
    return data;
  };
  const updateProfile = async (bodyObj: UpdateProfile) => {
    const data = await apiCall(
      CUSTOMERS_URLS.UpdateProfile,
      RequestMethod.POST,
      bodyObj
    );
    return data;
  };
  return {
    login,
    register,
    resendVerification,
    verifyRegistration,
    verifyLogin,
    updatePhone,
    verifyUpdatePhone,
    updateProfile,
  };
};
const customersRepository = CustomersRepository();
export default customersRepository;
